import { Carousel } from 'components/Carousels'
import { memo } from 'react'
import { ItemComponentCarousel } from './ItemComponentCarousel'
import { TrustPilotBadge } from './TrustPilotBadge'

const DefaultCarousel = memo(({ items, tabStyle, selected, onSlideChange, trustPilot }) => {
  return (
    <div className="relative mt-4 lg:mb-4">
      <Carousel
        autoPlay={true}
        carouselItems={items}
        itemComponent={ItemComponentCarousel}
        dataItem={{ tabStyle }}
        variant="preview-full"
        withIndicators={items?.length > 1}
        disableArrows={true}
        classNameIndicatorDots="flex bg-[#3300ff] mt-8 mb-8 lg:hidden hover:cursor-pointer"
        classNameIndicators="bg-transparent [&>div]:bg-[#c0cbd8]"
        idPrefix="hero-slider"
        interval={5000}
        navigateOnClick={true}
        scrollOnChange={false}
        classNameContainer="max-w-[509px] lg:max-w-none"
        className="p-0! sm:pl-4"
        setValue={selected}
        cbOnChange={onSlideChange}
      />
      <TrustPilotBadge
        trustPilot={trustPilot}
        className="items-center justify-center mb-8 flex lg:hidden lg:justify-start "
      />
    </div>
  )
})
DefaultCarousel.displayName = 'DefaultCarousel'

export { DefaultCarousel }
